<template>
  <div>
    <div class="d-flex">
      <v-menu
        ref="datepicker"
        v-model="datepicker"
        :close-on-content-click="false"
        transition="scale-transition"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            prepend-inner-icon="mdi-calendar"
            v-model="date"
            label="Date"
            readonly
            v-bind="attrs"
            v-on="on"
            dense
          />
        </template>
        <v-date-picker
          ref="picker"
          color="navy"
          v-model="date"
          :min="setMinDate ? $moment().format('YYYY-MM-DD') : null"
          @change="saveDate"
        ></v-date-picker>
      </v-menu>
      <v-select
        v-if="date && showTime"
        v-model="time"
        :items="times"
        dense
        hide-details
        @input="saveTime"
        class="ml-2"
        label="Time"
        style="max-width:145px;"
      />
    </div>
    <v-checkbox
      v-if="showSendNow"
      class="mt-n2"
      v-model="sendNow"
      label="or send within the next 5 minutes"
      @click="setSendNow"
    ></v-checkbox>
  </div>
</template>

<script>
export default {
  name: "DateTimePicker",
  data() {
    return {
      datepicker: false,
      date: null,
      time: null,
      sendNow: false,
    };
  },
  props: {
    showSendNow: {
      type: Boolean,
      required: false,
      default: true,
    },
    setMinDate: {
      type: Boolean,
      required: false,
      default: true,
    },
    showTime: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    times() {
      const desiredStartTime = "00:00";
      const interval = 30;
      const period = "m";
      const periodsInADay = this.$moment.duration(1, "day").as(period);

      let times = [];
      const startTime = this.$moment(desiredStartTime, "HH:mm");
      for (let i = 0; i <= periodsInADay; i += interval) {
        startTime.add(i === 0 ? 0 : interval, period);
        // if the selected date is today, the don't allow times already past
        if (this.setMinDate && this.date === this.$moment().format("YYYY-MM-DD")) {
          if (startTime.format("HH") <= this.$moment().format("HH")) {
            continue;
          }
        }
        times.push({ value: startTime.format("HH:mm"), text: startTime.format("HH:mm A") });
      }

      // remove elements to prevent end user confusion
      return times.slice(0, -1);
    },
  },
  methods: {
    setValues(timestamp) {
      let momentObj = this.$moment.utc(timestamp);
      let date = momentObj.format("YYYY-MM-DD");
      this.date = timestamp ? date : timestamp;
      this.time = momentObj.format("HH:mm");
    },
    saveDate(date) {
      this.$refs.datepicker.save(date);
      this.time = this.times[0]?.value;
      this.onChanged();
    },
    saveTime() {
      this.onChanged();
    },
    setSendNow() {
      if (this.sendNow) {
        const dateTime = this.$moment().format("YYYY-MM-DD HH:mm");
        return this.$emit("changed", dateTime);
      }
      this.onChanged();
    },
    onChanged() {
      if (this.date && this.time) {
        const dateTime = `${this.date} ${this.time}`;
        this.$emit("changed", this.showTime ? dateTime : this.date);
      }
    },
  },
};
</script>
